export type CommunityPostCategory = (typeof COMMUNITY_POST_CATEGORIES)[number];

export const COMMUNITY_POST_CATEGORIES = [
  '전체',
  '취업·이직',
  '기술',
  '모집·홍보',
  '잡담',
] as const;
